'use memo'

// web/src/features/event/components/EventTeamField.tsx
import { useScheduleTeams } from '@sportninja/common/features/game/gameForm/hooks/useGameOptions'
import { buildTeamOptions } from '@sportninja/common/features/event/teamSelection'
import { capitalizeWords } from '@sportninja/common/ts-utils'
import { SelectField } from 'src/features/profile/player/setupModal/components/FormikField'

interface EventTeamFieldProps {
  /** The competition the event belongs to — scopes the team list. */
  scheduleId: string
}

/**
 * Team select for a COMPETITION event.
 *
 * The LIST is the add/edit Game modal's — same endpoint, same React Query key
 * (`useScheduleTeams`), so opening this modal after the Game one costs no
 * request. The CONTROL is the form's own `SelectField`, not the Game modal's
 * `GameSearchField`: this field shares a row with Event Type and Event Name,
 * and GameSearchField labels in `SOLITUDE` where the form's fields label in
 * `WHITE` — two adjacent labels in different whites.
 *
 * Optional: an event may belong to the competition as a whole rather than to
 * any one team, so there is no required marker. Clearing it on edit unassigns
 * the team (`team_id: null`).
 *
 * Only rendered for a competition event: `/schedules/:id/teams/simple` is
 * scoped to a schedule, and a team-owned event already knows its team.
 */
const EventTeamField: React.FC<EventTeamFieldProps> = ({ scheduleId }) => {
  const { teams, isLoading } = useScheduleTeams(scheduleId)

  return (
    <SelectField
      name='teamId'
      label={capitalizeWords('Team')}
      placeholder={capitalizeWords('Select A Team')}
      options={buildTeamOptions(teams)}
      // A competition's team list runs long enough to need type-to-filter,
      // the same reason Event Type beside it is searchable.
      showSearch
      loading={isLoading}
    />
  )
}

export default EventTeamField
